// reach_ui/src/components/VastGPT/GenerateKnowledgeButton.js
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { ListItemIcon, ListItemText, MenuItem } from '@material-ui/core'
import { BookPlus } from 'mdi-material-ui'
import { toggleDialog } from '../../actions/view'
import { withRouter } from 'react-router-dom'

class GenerateKnowledgeButton extends Component {
  constructor(props) {
    super(props)

    this.state = { generating: false }
  }

  generateKnowledge = () => {
    this.setState({ generating: true })

    this.props.toggleDialog({
      open: true,
      dialog: 'AddOrEditKnowledge',
      options: {
        id: 'new',
        title: this.props.title,
        content: this.props.content,
      },
    })
    // const content = this.props.content
  }

  render() {
    return (
      <MenuItem
        disabled={this.state.generating}
        onClick={() => {
          this.props.handleClose()
          this.generateKnowledge()
        }}
      >
        <ListItemIcon>
          <BookPlus />
        </ListItemIcon>
        <ListItemText primary="Save as knowledge" />
      </MenuItem>
    )
  }
}

export default withRouter(
  connect(
    (state, { index }) => {
      const messages = state.VastGPT.messages?.slice(1)

      return {
        title: messages?.[index - 1]?.content,
        content: messages?.[index]?.content,
      }
    },
    dispatch =>
      bindActionCreators(
        {
          toggleDialog,
        },
        dispatch,
      ),
  )(GenerateKnowledgeButton),
)
